module.exports = __webpack_public_path__ + "static/media/situacional.d33e9429.png";